module.exports = __webpack_public_path__ + "media/images/ico_comment-6fba15fcb5712cc4e8beefa419db1211.png";